import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class PushToTalkService {

  constructor(private http : HttpClient) { }

  getPushToTalkGroup(){
    return this.http.get<any>(urls.BASE_URL + urls.PUSH_TO_TALK)
      .pipe(
        catchError(errorHandl)
      );
  }

  getPushToTalkGroupById(id){
    return this.http.get<any>(urls.BASE_URL + urls.PUSH_TO_TALK + '/' + id )
      .pipe(
        catchError(errorHandl)
      );
  }

  getPushToTalkMessages(queryParams?) {
    const params = new HttpParams({ fromObject: queryParams });

    return this.http.get<any>(urls.BASE_URL + urls.PUSH_TO_TALK_MESSAGES, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  getAllPushToTalkMessages(queryParams?) {
    const params = new HttpParams({ fromObject: queryParams });

    return this.http.get<any>(urls.BASE_URL + urls.ALL_PUSH_TO_TALK_MESSAGES, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  sendAudioMessage(payload) {

    return this.http.post<any>(urls.BASE_URL + urls.PUSH_TO_TALK_MESSAGES, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  markAsReadMessage(payload) {

    return this.http.put<any>(urls.BASE_URL + urls.PUSH_TO_TALK_MESSAGES, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  createGroup(payload, id){
    if(id){
      return this.http.put<any>(urls.BASE_URL + urls.PUSH_TO_TALK + '/' + id, payload)
        .pipe(
          catchError(errorHandl)
        );
    }else {
      return this.http.post<any>(urls.BASE_URL + urls.PUSH_TO_TALK, payload)
        .pipe(
          catchError(errorHandl)
        );
    }

  }

}
